import { Component, type OnInit, type OnDestroy, ChangeDetectorRef } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  type User, UserService
} from '@inside-hub-app/customer-portal-b2c-client'
import { SharedService } from '../../../../services/shared.service'
import { DataService } from '../../../../services/data.service'
import { RevolutionUserImgDetailsPopupComponent } from '../user-img-details-popup/user-img-details.component'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { UserInitialsPipe } from '../../../../pipes/user-initials'
import { UserNamePipe } from '../../../../pipes/username-pipe'
@Component({
  selector: 'customer-portal-app-revolution-my-account-head',
  standalone: true,
  templateUrl: './my-account-head.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    UserInitialsPipe,
    UserNamePipe
  ]
})
export class MyAccountHeadComponent implements OnInit, OnDestroy {
  public user: User
  loading = true
  lang

  sub = {
    onUserLoaded: null,
    onLanguageChange: null
  }

  showAltIcon = false
  profilePictureUrl
  constructor (
    private readonly data: DataService,
    private readonly sharedService: SharedService,
    public cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private readonly userService: UserService
  ) {}

  ngOnInit (): void {
    this.load()
  }

  load (): void {
    this.sub.onUserLoaded = this.data.onUserLoaded.subscribe(user => {
      this.lang = undefined
      this.user = undefined
      this.cdRef.detectChanges()
      this.showAltIcon = false
      this.loading = false
      this.user = user
      this.lang =
        this.user != null && user.language != null && user.language.length !== 0
          ? user.language.find(s => s.primary).language
          : ''
      this.profilePictureUrl = user.profilePictureUrl
    })
    this.sub.onLanguageChange = this.data.onLanguageChange.subscribe(
      newLanguage => {
        this.lang = undefined
        this.cdRef.detectChanges()
        this.lang = newLanguage.toUpperCase()
      }
    )
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }

  openUserImgDetails (): void {
    const dialogRef = this.dialog.open(RevolutionUserImgDetailsPopupComponent, {
      data: this.user,
      panelClass: 'mat-dialog-cpt'
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result?.url != null) {
        this.data.getUser()
      }
    })
  }
}
